import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import styled, { css } from 'styled-components';

import { AvatarImage as _AvatarImage } from 'components/Core/Images';

const Container = styled.div`
  display: flex;
  height: 100%;
`;

const noMargin = css `
  margin-bottom: 0;
`;

const CurrentRouteText = styled.p`
  ${noMargin}
`;

const UserContainer = styled.div`
  flex: 1;
  align-items: center;
  justify-content: flex-end;
  display: flex;
`;

const AvatarImage = styled(_AvatarImage)`
  margin-right: 10px;
`;

const UserDetailContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const DetailText = styled.p`
  ${noMargin}
  line-height: 20px;
  font-size: 12px;
`;

const CreditText = DetailText.extend`
  font-size: 14px;
`;

const enhance = compose(
  withRouter,
  connect(
    state => ({
      user: state.auth.user,
      isLoggedIn: state.auth.loggedIn
    })
  )
);

const Header = props => {
  const { isLoggedIn, user, title } = props;
  return (
    <Container>
      <CurrentRouteText>{title}</CurrentRouteText>
      {isLoggedIn && (
        <UserContainer>
          <AvatarImage size={35} image={user.avatar_image} />
          <UserDetailContainer>
            <DetailText>Hello, {user.name.first}</DetailText>
            <CreditText>Credit: THB {user.partner_credit}</CreditText>
          </UserDetailContainer>
        </UserContainer>
      )}
    </Container>
  );
};

export default enhance(Header);



// WEBPACK FOOTER //
// ./src/components/Layout/Header.js